import { render, staticRenderFns } from "./Add-people.vue?vue&type=template&id=938b36d0&scoped=true&"
import script from "./Add-people.vue?vue&type=script&lang=js&"
export * from "./Add-people.vue?vue&type=script&lang=js&"
import style0 from "./Add-people.vue?vue&type=style&index=0&id=938b36d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938b36d0",
  null
  
)

export default component.exports